module.exports = __webpack_public_path__ + "static/support-vehicles-b42263bb61b745f79bb1bfed8503b921.jpg";